export interface ErrorMessageProps {
  message: string;
  requestId?: string;
  onRetry?: () => void;
}

export function ErrorMessage({ message, requestId, onRetry }: ErrorMessageProps) {
  return (
    <div
      role="alert"
      className="flex items-start gap-3 px-4 py-3.5 rounded-lg bg-red-50 text-red-800 text-sm"
    >
      <svg className="h-4 w-4 shrink-0 mt-0.5 text-red-500" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clipRule="evenodd" />
      </svg>
      <div className="flex-1 min-w-0">
        <p className="m-0 font-medium text-sm">{message}</p>
        {requestId && (
          <p className="mt-1 mb-0 text-xs text-red-600/70">
            Reference: {requestId}
          </p>
        )}
        {onRetry && (
          <button
            onClick={onRetry}
            className="mt-2.5 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md border border-red-200 bg-white text-red-700 text-xs font-medium cursor-pointer hover:bg-red-50 transition-all"
          >
            <svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            Try again
          </button>
        )}
      </div>
    </div>
  );
}
